import { render, staticRenderFns } from "./ChatForm.vue?vue&type=template&id=66aa6f26"
import script from "./ChatForm.vue?vue&type=script&lang=js"
export * from "./ChatForm.vue?vue&type=script&lang=js"
import style0 from "./ChatForm.vue?vue&type=style&index=0&id=66aa6f26&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports